export const PayrollOverviewDetailsGetters = {
  PayrollOverviewDetails: 'payrollOverviewDetails',
  PayrollOverviewDetailsIsLoading: 'payrollOverviewDetailsIsLoading',
  PayrollOverviewTimesheets: 'payrollOverviewTimesheets',
  PayrollOverviewTimesheetsIsLoading: 'payrollOverviewTimesheetsIsLoading',
  PayrollOveriewTimeSheetsSortOrder: 'payrollOveriewTimeSheetsSortOrder',
  PayrollOverviewTimesheetsCount: 'payrollOverviewTimesheetsCount',
  PayrollOveriewTimeSheetsPerPage: 'payrollOveriewTimeSheetsPerPage',
  PayrollOveriewTimeSheetsListingOffset: 'payrollOveriewTimeSheetsListingOffset'
};
export const PayrollOverviewDetailsActions = {
  RetrievepayrollOverviewDetails: 'retrievepayrollOverviewDetails',
  RetrievePayrollOverviewTimesheets: 'retrievePayrollOverviewTimesheets',
  SetPayrollOverviewTimeSheetsSortOrder: 'setPayrollOverviewTimeSheetsSortOrder',
  RetrievePayrollOverviewTimesheetsCount: 'retrievePayrollOverviewTimesheetsCount',
  SetPayrollOverviewTimeSheetsPaginationParameters:
    'setPayrollOverviewTimeSheetsPaginationParameters',
  ProcessPayrollOverviewResults: 'processPayrollOverviewResults'
};
export const PayrollOverviewDetailsMutations = {
  SetPayrollOverviewDetailsLoading: 'setPayrollOverviewDetailssLoading',
  SetPayrollOverviewDetails: 'setPayrollOverviewDetails',
  SetPayrollOverviewTimesheets: 'setPayrollOverviewTimesheets',
  SetPayrollOverviewTimesheetsLoading: 'setPayrollOverviewTimesheetsLoading',
  SetPayrollOverviewTimeSheetsSortOrder: 'setPayrollOverviewTimeSheetsSortOrder',
  SetPayrollOverviewTimesheetsCount: 'setPayrollOverviewTimesheetsCount',
  UpdatePayrollOverviewimeSheetsPaginationParameters:
    'updatePayrollOverviewimeSheetsPaginationParameters',
  ResetPayrollOverviewTimeSheetsPaginationOffset: 'resetPayrollOverviewTimeSheetsPaginationOffset'
};
